import { forwardRef } from 'react'
import type { IconProps } from '../icon-props'
import { Icon } from '../icon'
/** @preview ![icon](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ3aGl0ZSIvPjxwYXRoIGZpbGw9IiMxMTE5MjgiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0ibTE4LjU1NiA4LjY1Ny0xLjQxNC0xLjQxNC03LjQ4NSA3LjQ4NS0zLjI0My0zLjI0M0w1IDEyLjlsMy4yNDMgMy4yNDIgMS40MTQgMS40MTR6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=) */
export const IconCheck = forwardRef<SVGElement, IconProps>((props, ref) => (
    <Icon ref={ref} {...props}>
        <path
            fill="#111928"
            fillRule="evenodd"
            d="m18.556 8.657-1.414-1.414-7.485 7.485-3.243-3.243L5 12.9l3.243 3.242 1.414 1.414z"
            clipRule="evenodd"
        />
    </Icon>
))
IconCheck.displayName = 'IconCheck'
